/* ==========================================================================
   KIDDYPI COLLECTION PAGE — assets/component-collection-premium.js
   Replaces assets/collection.js. Vanilla JS only, additive to Dawn's own
   facets.js (never touches filtering/sorting logic itself).
   ========================================================================== */
(function () {
  'use strict';

  // Correct single-init pattern (previous double-init bug — see project
  // notes — caused duplicated "Read more" buttons on defer-loaded scripts).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initDescriptionToggle();
    initScrollReveal();
    initStickyFilterBar();
    initResetFilters();
    initHeroParallax();
    initButtonRipple();
    initTagBadges();
  }

  /* ---------------- Hero description expand/collapse ---------------- */
  function initDescriptionToggle() {
    var desc = document.querySelector('.collection-hero__description');
    if (!desc) return;
    if (desc.nextElementSibling && desc.nextElementSibling.classList.contains('collection-hero__description-toggle')) return;
    var paragraphs = desc.querySelectorAll('p');
    if (paragraphs.length <= 1) return;

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'collection-hero__description-toggle';
    toggle.textContent = 'Read more';
    desc.insertAdjacentElement('afterend', toggle);

    toggle.addEventListener('click', function () {
      var expanded = desc.classList.toggle('is-expanded');
      toggle.textContent = expanded ? 'Show less' : 'Read more';
    });
  }

  /* ---------------- Scroll reveal ---------------- */
  function initScrollReveal() {
    var els = document.querySelectorAll('.kcp-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------- Sticky filter bar shadow toggle ---------------- */
  function initStickyFilterBar() {
    var bar = document.querySelector('.facets-wrapper');
    if (!bar || !('IntersectionObserver' in window)) return;
    // A 1px-tall sentinel placed just above the bar; when it scrolls out
    // of view, the bar has become "stuck" to the top.
    var sentinel = document.createElement('div');
    sentinel.style.cssText = 'position:relative;height:1px;';
    bar.parentNode.insertBefore(sentinel, bar);

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-stuck', !entry.isIntersecting);
      });
    }, { threshold: 0, rootMargin: '-1px 0px 0px 0px' });
    io.observe(sentinel);
  }

  /* ---------------- Reset filters ---------------- */
  function initResetFilters() {
    var bar = document.querySelector('.facets-wrapper');
    if (!bar) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kcp-reset-filters';
    btn.textContent = 'Reset filters';
    bar.appendChild(btn);

    function hasActiveFilters() {
      return window.location.search.length > 1 &&
        /[?&](filter\.|sort_by=)/.test(window.location.search) &&
        document.querySelector('.active-facets, .active-facets__button');
    }
    function refreshVisibility() {
      btn.classList.toggle('is-visible', !!document.querySelector('.active-facets__button'));
    }
    refreshVisibility();
    // Dawn's facets.js re-renders the filter area via history/XHR; watch
    // for that instead of only checking once on load.
    var observer = new MutationObserver(refreshVisibility);
    observer.observe(bar, { childList: true, subtree: true });

    btn.addEventListener('click', function () {
      window.location.href = window.location.pathname;
    });
  }

  /* ---------------- Hero icon mouse parallax (desktop only, subtle) ---------------- */
  function initHeroParallax() {
    var visual = document.querySelector('.collection-hero__visual');
    if (!visual || window.matchMedia('(pointer: coarse)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    visual.setAttribute('data-parallax', '');
    var icons = visual.querySelectorAll('.collection-hero__icon');

    visual.addEventListener('mousemove', function (e) {
      var rect = visual.getBoundingClientRect();
      var px = (e.clientX - rect.left) / rect.width - 0.5;
      var py = (e.clientY - rect.top) / rect.height - 0.5;
      icons.forEach(function (icon, i) {
        var depth = 6 + (i % 3) * 4; // vary depth slightly per icon
        icon.style.transform = 'translate(' + (px * depth) + 'px,' + (py * depth) + 'px)';
      });
    });
    visual.addEventListener('mouseleave', function () {
      icons.forEach(function (icon) { icon.style.transform = ''; });
    });
  }

  /* ---------------- Button ripple ---------------- */
  function initButtonRipple() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.collection-hero__cta, .collection-cta__button, .collection-story__cta');
      if (!btn) return;
      var rect = btn.getBoundingClientRect();
      var ripple = document.createElement('span');
      var size = Math.max(rect.width, rect.height);
      ripple.className = 'kcp-ripple';
      ripple.style.width = ripple.style.height = size + 'px';
      ripple.style.left = (e.clientX - rect.left - size / 2) + 'px';
      ripple.style.top = (e.clientY - rect.top - size / 2) + 'px';
      btn.appendChild(ripple);
      window.setTimeout(function () { ripple.remove(); }, 650);
    });
  }

  /* ---------------- Tag-driven Best Seller / New badges ----------------
     Only ever shown when a product genuinely carries the tag — never
     added by default. Reads a small JSON payload each card can carry via
     a data attribute (see the Liquid patch), rather than guessing at
     card-product.liquid's exact tag output, which hasn't been shared. */
  function initTagBadges() {
    document.querySelectorAll('[data-kcp-tags]').forEach(function (card) {
      var tags = (card.getAttribute('data-kcp-tags') || '').toLowerCase().split(',').map(function (t) { return t.trim(); });
      var media = card.querySelector('.card__media, .media');
      if (!media) return;
      if (tags.indexOf('bestseller') !== -1) {
        media.insertAdjacentHTML('beforeend', '<span class="kcp-badge kcp-badge--bestseller">Best Seller</span>');
      }
      if (tags.indexOf('new') !== -1) {
        media.insertAdjacentHTML('beforeend', '<span class="kcp-badge kcp-badge--new">New</span>');
      }
    });
  }
})();